import Api from '@utils/api';
import ApiAuth from '@utils/api-auth';
import { Alumnos, AlumnosTramiteDocumentos, Usuarios } from '@constants/urls';

const PREFIJOS = {
	CAMBIO_DE_PLANTEL: 'B',
	COMBALIDADOS: 'C'
};

export const state = {
	isLoading: false,
	isLoadingFormulario: false,
	isLoadingVerificando: false,
	alumno: {},
	documentos: {
		oficioNoInconvenientes: {},
		comprobanteEFirma: {},
		curp: {},
		actaNacimiento: {},
		certificadoBachillerato: {},
		certificadoLicenciatura: {},
		oficioLiberacionServicioSocial: {},
		acreditacionIdiomaIngles: {},
		revalidacionOProrroga: {},
		documentoTitulacion: {}
	},
	alumnos: [],
	totalAlumnos: 0,
	mensajes: [],
	historicos: []
};

export const getters = {
	isLoading: function(state) {
		return state.isLoading;
	},
	isLoadingVerificando: function(state) {
		return state.isLoadingVerificando;
	},
	isLoadingFormulario: function(state) {
		return state.isLoadingFormulario;
	},
	getAlumno: function(state) {
		return state.alumno;
	},
	getAlumnos: function(state) {
		return state.alumnos;
	},
	getMensajes: function(state) {
		return state.mensajes;
	},
	getHistoricos: function(state) {
		return state.historicos;
	},
	getTotalAlumnos: function(state) {
		return state.totalAlumnos;
	},
	getStepActive: function(state) {
		return state.alumno.stepActive;
	},
	getDocumentos: function(state) {
		return state.documentos;
	},
	isAlumnoPlanViejo: function(state) {
		const limiteAnio = 9;
		let anioIncripcion = 0;
		const { numeroControl } = state.alumno;
		if (!numeroControl || numeroControl.length < 2) return false;
		if (
			numeroControl[0].toUpperCase() === PREFIJOS.CAMBIO_DE_PLANTEL ||
			numeroControl[0].toUpperCase() === PREFIJOS.COMBALIDADOS
		) {
			anioIncripcion = parseInt(
				numeroControl[1].toString() + numeroControl[2].toString()
			);
		} else {
			anioIncripcion = parseInt(
				numeroControl[0].toString() + numeroControl[0].toString()
			);
		}
		return anioIncripcion <= limiteAnio;
	},
	isAlumnoDeCambioOCombalidado: function(state, getters) {
		return getters.isAlumnoDeCambioPlantel || getters.isAlumnoCombalidado;
	},
	isAlumnoDeCambioPlantel: function(state) {
		const { numeroControl } = state.alumno;
		if (!numeroControl || numeroControl.length < 2) return false;
		return numeroControl[0].toUpperCase() === PREFIJOS.CAMBIO_DE_PLANTEL;
	},
	isAlumnoCombalidado: function(state) {
		const { numeroControl } = state.alumno;
		if (!numeroControl || numeroControl.length < 2) return false;
		return numeroControl[0].toUpperCase() === PREFIJOS.COMBALIDADOS;
	}
};

export const mutations = {
	SET_LOADING: function(state, newValue) {
		state.isLoading = newValue;
	},
	SET_LOADING_ALUMNO: function(state, newValue) {
		// state.isLoading = newValue;
	},
	SET_STEP_ACTIVE: function(state, newValue) {
		state.alumno.stepActive = newValue;
	},
	SET_PRIORITARIO: function(state, newValue) {
		for (let i = 0; i < state.alumnos.length; i++) {
			const alumno = state.alumnos[i];
			if (alumno.numeroControl === state.alumno.numeroControl) {
				alumno.prioritario = newValue;
				break;
			}
		}
		state.alumno.prioritario = newValue;
	},
	SET_MENSAJES: function(state, newValue) {
		state.mensajes = newValue;
	},
	SET_HISTORICOS: function(state, newValue) {
		state.historicos = newValue;
	},
	SET_LOADING_VERIFICANDO: function(state, newValue) {
		state.isLoadingVerificando = newValue;
	},
	SET_LOADING_FORMULARIO: function(state, newValue) {
		state.isLoadingFormulario = newValue;
	},
	SET_ALUMNO: function(state, newValue) {
		state.alumno = newValue;
	},
	SET_ALUMNOS: function(state, newValue) {
		state.alumnos = newValue;
	},
	SET_TOTAL_ALUMNOS: function(state, newValue) {
		state.totalAlumnos = newValue;
	},
	SET_DOCUMENTOS: function(state, newValue) {
		state.documentos = newValue;
	},
	SET_CORREO_VERIFICADO: function(state, newValue) {
		state.alumno.correoVerificado = newValue;
	}
};

export const actions = {
	establecerLoading: function({ commit }, loading) {
		commit('SET_LOADING', !!loading);
	},
	establecerAlumno: function({ commit }, alumno) {
		commit('SET_ALUMNO', alumno);
	},
	establecerDocumentos: function(
		{ commit },
		documentos,
		onComplete = () => {}
	) {
		commit('SET_DOCUMENTOS', documentos);
		onComplete();
	},
	siguientePaso: function({ commit, getters }) {
		commit('SET_LOADING_FORMULARIO', true);
		const stepActive = getters.getStepActive + 1;
		Api.Post(Alumnos.ACTUALIZAR_STEP_ACTIVE(getters.getAlumno.numeroControl), {
			stepActive
		})
			.then(() => {
				commit('SET_STEP_ACTIVE', stepActive);
			})
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	},
	obtenerAlumnosPaginado: function({ commit }, params) {
		commit('SET_LOADING', true);
		Api.Post(Alumnos.LISTAR_PAGINADO, params)
			.then((response) => {
				const alumnos = response.data.data.data;
				const total = response.data.data.total;
				commit('SET_TOTAL_ALUMNOS', total);
				commit('SET_ALUMNOS', alumnos);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	obtenerAlumnos: function({ commit }) {
		commit('SET_LOADING', true);
		Api.Get(Alumnos.LISTAR)
			.then((response) => {
				const alumnos = response.data.data;
				commit('SET_ALUMNOS', alumnos);
			})
			.finally(() => {
				commit('SET_LOADING', false);
			});
	},
	obtenerAlumno: function({ commit }, numeroControl = '') {
		commit('SET_LOADING_ALUMNO', true);
		Api.Get(Alumnos.OBTENER_POR_NUMERO_CONTROL(numeroControl))
			.then((response) => {
				const alumno = response.data.data;
				commit('SET_ALUMNO', {
					numeroControl: alumno.numeroControl,
					nombre: alumno.nombre,
					curp: alumno.curp,
					curpIsEmpty: !alumno.curp,
					carrera: {
						clave: alumno.carrera.id,
						nombre: alumno.carrera.nombre
					},
					nacionalidad: alumno.nacionalidad.nombre,
					nacionalidadId: alumno.nacionalidad.id || null,
					telefonos: alumno.telefonos,
					correoElectronico: alumno.correoElectronico,
					correoElectronicoVerificado: alumno.correoVerificado || '',
					correoVerificado: alumno.correoVerificado,
					opcionTitulacion: alumno.opcionTitulacion.id || null,
					stepActive: alumno.stepActive,
					semestreActual: alumno.semestreActual,
					prioritario: alumno.prioritario,
					estatus: alumno.estatus,
					numeroOficio: alumno.numeroOficio,
					fechaOficio: alumno.fechaOficio,
					seguimiento: alumno.seguimiento,
					expedienteFisico: alumno.expedienteFisico,
					observacionesExpediente: alumno.observacionesExpediente,
					numeroPaquete: alumno.numeroPaquete,
					tieneFotografias: alumno.tieneFotografias
				});
				Api.Get(
					AlumnosTramiteDocumentos.OBTENER_POR_NUMERO_CONTROL(numeroControl)
				)
					.then((response) => {
						const documentos = response.data.data;
						const obj = {};
						for (let i = 0; i < documentos.length; i++) {
							const documento = documentos[i];
							obj[documento.documentoTitulacion.codigo] = {
								id: documento.id,
								subido: documento.subido,
								verificado: documento.verificado,
								valido: documento.valido,
								nombreArchivo: documento.nombreArchivo,
								urlArchivo: documento.urlArchivo,
								observacion: documento.observacion,
								version: documento.version,
								descripcion: documento.documentoTitulacion.descripcion,
								nota: documento.documentoTitulacion.nota,
								paso: documento.documentoTitulacion.paso
							};
						}
						commit('SET_DOCUMENTOS', obj);
					})
					.finally(() => {
						commit('SET_LOADING_ALUMNO', false);
					});
			})
			.finally(() => {
				// commit('SET_LOADING', false);
			});
	},
	verificarCorreo: function(
		{ commit },
		{ numeroControl, params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_VERIFICANDO', true);
		Api.Post(Alumnos.ENVIAR_CORREO(numeroControl), params)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_VERIFICANDO', false), 300)
			);
	},
	actualizarDatosAlumno: function(
		{ commit },
		{ numeroControl, params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(Alumnos.ACTUALIZAR_INFORMACION(numeroControl), params)
			.then(() => {
				onComplete();
			})
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_VERIFICANDO', false), 300)
			);
		setTimeout(() => {
			commit('SET_LOADING_FORMULARIO', false);
			onComplete();
		}, 2000);
	},
	reenviarCodigoCorreo: function(
		{ commit },
		{ numeroControl, params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_VERIFICANDO', true);
		Api.Post(Alumnos.ENVIAR_CORREO(numeroControl), params)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_VERIFICANDO', false), 300)
			);
	},
	verificarCodigoCorreo: function(
		{ commit },
		{ numeroControl, params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_VERIFICANDO', true);
		Api.Post(Alumnos.VERIFICAR_CORREO(numeroControl), params)
			.then(() => {
				commit('SET_CORREO_VERIFICADO', true);
				onComplete();
			})
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_VERIFICANDO', false), 300)
			);
	},
	aprobarDocumento: function(
		{ commit },
		{ numeroControl = '', params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(AlumnosTramiteDocumentos.APROBAR_DOCUMENTO(numeroControl), params)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	},
	enviarMensajeAlumno: function(
		{ commit },
		{ numeroControl = '', params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(Alumnos.ENVIAR_MENSAJE(numeroControl), params)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	},
	rechazarDocumento: function(
		{ commit },
		{ numeroControl = '', params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(AlumnosTramiteDocumentos.RECHAZAR_DOCUMENTO(numeroControl), params)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	},
	rechazarDocumentoConSolicitud: function(
		{ commit },
		{ numeroControl = '', params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(
			AlumnosTramiteDocumentos.RECHAZAR_DOCUMENTO_CON_SOLICITUD(numeroControl),
			params
		)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	},
	actualizarPrioritarioAlumno: function(
		{ commit },
		{ numeroControl = '', params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(Alumnos.ACTUALIZAR_PRIORITARIO(numeroControl), params)
			.then(() => {
				commit('SET_PRIORITARIO', params.prioritario);
			})
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	},
	obtenerMensajesAlumno: function(
		{ commit },
		{ numeroControl = '', onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Get(Alumnos.OBTENER_MENSAJES(numeroControl))
			.then((response) => {
				const mensajes = response.data.data;
				commit('SET_MENSAJES', mensajes);
			})
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	},
	obtenerHistoricosAlumno: function(
		{ commit },
		{ numeroControl = '', onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Get(Alumnos.OBTENER_HISTORICOS(numeroControl))
			.then((response) => {
				const historicos = response.data.data;
				commit('SET_HISTORICOS', historicos);
			})
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	},
	todosLosDocumentoAprobados: function(
		{ commit },
		{
			numeroControl = '',
			paso = 0,
			params,
			onComplete = () => {},
			onError = () => {}
		}
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(
			AlumnosTramiteDocumentos.DOCUMENTO_APROBADOS(numeroControl, paso),
			params
		)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	},
	activarAlumno: function(
		{ commit },
		{ numeroControl = '', params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(Alumnos.ACTIVAR(numeroControl), params)
			.then((response) => {
				const contrasenia = response.data.data;
				ApiAuth.Put(Usuarios.ACTUALIZAR_CONTRASENIA(numeroControl), {
					contrasenia
				})
					.then(onComplete)
					.catch(onError)
					.finally(() =>
						setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
					);
			})
			.catch(onError);
	},
	inactivarAlumno: function(
		{ commit },
		{ numeroControl = '', params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(Alumnos.INACTIVAR(numeroControl), params)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	},
	generarDocumentoNoInconvenientes: function(
		{ commit },
		{ numeroControl = '', params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.PostBlob(
			AlumnosTramiteDocumentos.GENERAR_DOCUMENTO_NO_INCONVENIENTES(
				numeroControl
			)
		)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	},
	enviarDocumentoNoInconvenientes: function(
		{ commit },
		{ numeroControl = '', params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(
			AlumnosTramiteDocumentos.ENVIAR_DOCUMENTO_NO_INCONVENIENTES(numeroControl)
		)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	},
	subirDocumento: function(
		{ commit },
		{
			numeroControl,
			params,
			archivos,
			onComplete = () => {},
			onError = () => {}
		}
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.PostFile(
			AlumnosTramiteDocumentos.SUBIR_DOCUMENTO(numeroControl),
			archivos,
			params
		)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 0)
			);
	},
	guardarExpedienteFisico: function(
		{ commit },
		{ numeroControl, params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(Alumnos.GUARDAR_EXPEDIENTE_FISICO(numeroControl), params)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 0)
			);
	},
	restablecerOpcionTitulacion: function(
		{ commit },
		{ numeroControl, params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(Alumnos.RESTABLECER_OPCION_TITULACION(numeroControl), params)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 0)
			);
	},
	cambiarTieneFotografiasAlumno: function(
		{ commit },
		{ numeroControl, params, onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.Post(Alumnos.CAMBIAR_TIENE_FOTOGRAFIAS(numeroControl), params)
			.then(onComplete)
			.catch(onError)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 0)
			);
	},
	obtenerZipArchivos: function(
		{ commit },
		{ numeroControl = '', onComplete = () => {}, onError = () => {} }
	) {
		commit('SET_LOADING_FORMULARIO', true);
		Api.PostBlob(AlumnosTramiteDocumentos.OBTENER_ZIP(numeroControl), {
			responseType: 'arraybuffer'
		})
			.then(onComplete)
			.finally(() =>
				setTimeout(() => commit('SET_LOADING_FORMULARIO', false), 300)
			);
	}
};
